
import { Vue, Options, Prop } from 'vue-property-decorator';

import MaterialLinearProgress from '@/components/material/LinearProgress.vue';

@Options({
    components: {
        MaterialLinearProgress
    }
})
export default class LinearProgress extends Vue {

    @Prop(String) readonly text!: string;
    @Prop(Boolean) readonly determinate!: boolean;

    get progress(): number {
        return this.$store.state.progress.progress / this.$store.state.progress.max;
    }
}
